import { Autocomplete, Chip, TextField } from "@mui/material";
import { forwardRef } from "react";
import { useController } from "react-hook-form";

const CustomMultiSelectField = forwardRef(({ field, control }, ref) => {
  const { field: fieldProps, fieldState } = useController({
    control,
    name: field.name,
  });

  return (
    <Autocomplete
      {...fieldProps}
      options={field.choices || []}
      getOptionLabel={(option) => option.label}
      multiple
      value={field.choices.filter((opt) =>
        fieldProps.value?.includes(opt.value),
      )}
      onChange={(_, newValue) => {
        fieldProps.onChange(newValue.map((opt) => opt.value));
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={field.label}
          helperText={fieldState.error?.message || field.help_text || ""}
          error={!!fieldState.error}
        />
      )}
      renderValue={(selected, getItemProps) => {
        return selected.map((option, index) => {
          const itemProps = getItemProps({ index });
          const { key, ...rest } = itemProps;

          return (
            <Chip
              key={key || `chip-${index}`}
              {...rest}
              label={`${option.label}`}
            />
          );
        });
      }}
      disabled={field.disabled}
      sx={{ display: field.hidden ? "none" : "block" }}
      slotProps={{
        paper: {
          sx: {
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.4)",
            backgroundColor: "rgba(250,250,250)",
          },
        },
      }}
    />
  );
});

//CustomMultiSelectField.toComponent = ({field, value}) => {
//  return field.choices.filter((v) => value.includes(v.value)) || [];
//}

export default CustomMultiSelectField;
